import { createFileRoute } from '@tanstack/react-router';
import { ReportsPage } from '@/features/reports/reports-page.js';
import { reportsSearchSchema } from '@/features/reports/search.js';

export const Route = createFileRoute('/_app/reports')({
  validateSearch: reportsSearchSchema,
  component: ReportsPage,
});
